import { NgModule } from '@angular/core';
import { AppDropdown, AppDropdownAnchor, AppDropdownToggle, AppDropdownMenu, AppDropdownSubmenu, AppDropdownItem, AppDropdownBackButton } from './dropdown';

export { AppDropdown, AppDropdownAnchor, AppDropdownToggle, AppDropdownMenu, AppDropdownSubmenu, AppDropdownItem, AppDropdownBackButton } from './dropdown';

const NGB_DROPDOWN_DIRECTIVES = [AppDropdown, AppDropdownAnchor, AppDropdownToggle, AppDropdownMenu, AppDropdownSubmenu, AppDropdownItem, AppDropdownBackButton];

@NgModule({ declarations: NGB_DROPDOWN_DIRECTIVES, exports: NGB_DROPDOWN_DIRECTIVES })
export class AppDropdownModule {}
